<div class="my-24">
  <form [formGroup]="form">
    <div class="flex-row-container gap-32">
      <mat-form-field class="flex-2">
        <mat-label>{{ 'MODAL_STATEMENT_ACC.DATES_RANGE' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="from" />
          <input matEndDate formControlName="to" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon class="calendar" matDatepickerToggleIcon>
            <img src="/assets/svg/calendar.svg" />
          </mat-icon>
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-hint>DD/MM/YYYY - DD/MM/YYYY</mat-hint>
        <mat-error *ngIf="form.controls['from'].hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="form.controls['to'].hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>
      <button mat-flat-button color="primary" class="basis-25" [disabled]="form.invalid || isLoading" (click)="showPreviewOnline()">
        <div class="relative center">
          <div *ngIf="isLoading" class="absolute spinner-position">
            <mat-spinner [diameter]="20" color="primary"></mat-spinner>
          </div>
          {{'MODAL_STATEMENT_ACC.PREVIEW_BUTTON' | translate}}
        </div>
      </button>
    </div>
  </form>
</div>
